import { radioButtonImg } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'radioButton',
  label: 'Radio Button',
  category: 'Inputs',
  image: radioButtonImg,
};
